import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalculationResults } from '../../backend-response-models/calc-interfaces.helper';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PDFService {
  constructor(private httpClient: HttpClient) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getPdfGeneration(url: string): Promise<any> {
    const headers = new HttpHeaders().set('x-api-key', 'mytestkey');
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'json',
    };
    const apiBaseUrl = environment.apiBaseUrl;

    const encodeUrl = encodeURIComponent(url);
    const fullUrl = `${apiBaseUrl}/dashboard/pdf-generate?url=${encodeUrl}`;
    const data = await firstValueFrom(this.httpClient.get(fullUrl, options));

    //Data is a buffer we now need to recrate the pdf file
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const blob = new Blob([data as any], { type: 'application/pdf' });
    this.downloadPdf(blob, 'report.pdf');
    return;
  }

  private downloadPdf(blob: Blob, filename: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    // Clean up
    setTimeout(() => URL.revokeObjectURL(link.href), 100);
  }
}
